/**
 * Entidade de domínio que representa a sub-sessão de dispositivo obtida ao
 * autenticar com um PIN de evento (`POST /events/auth-pin`, HUB-21).
 *
 * A fonte primária continua sendo o estado em memória (React state) desta
 * entidade. Isso **deixou de valer sem exceção** desde a HUB-236 (ADR-003,
 * Adendo 2026-07-25 — Correção 2): `AuthPinUseCase` também espelha um
 * subconjunto mínimo destes campos (`jwtToken`/`eventId`/`deviceId`/
 * `expiresAt`) em IndexedDB (`ActiveSessionSnapshot`, object store
 * `activeSession`), único jeito do Service Worker autenticar a
 * sincronização em segundo plano via Background Sync — que dispara mesmo
 * com a aba fechada, sem acesso a este estado em memória. A decisão da
 * HUB-147 ("sem IndexedDB/offline") permanece válida só para esta entidade
 * em si, não para o token que ela carrega.
 */
export interface DeviceSession {
  readonly jwtToken: string;
  readonly eventId: string;
  readonly agencyId: string;
  readonly deviceId: string;
  readonly startedAt: Date;
  readonly expiresAt: Date;
}

export function createDeviceSession(raw: unknown): DeviceSession {
  const data = raw as Record<string, unknown>;

  return {
    jwtToken: String(data['jwt_token'] ?? ''),
    eventId: String(data['event_id'] ?? ''),
    agencyId: String(data['agency_id'] ?? ''),
    deviceId: String(data['device_id'] ?? ''),
    startedAt: new Date(String(data['started_at'] ?? '')),
    expiresAt: new Date(String(data['expires_at'] ?? '')),
  };
}
